var map = {
	"./3dImg.png": [
		21113,
		1113
	],
	"./ProgramMadeForYouImg.png": [
		15873,
		5873
	],
	"./YoHealth.png": [
		38957,
		8957
	],
	"./aboutUs/cards.png": [
		5648,
		5648
	],
	"./aboutUs/copia.png": [
		98629,
		8629
	],
	"./aboutUs/copiaLight.png": [
		18953,
		8953
	],
	"./aboutUs/jonathan.png": [
		68482,
		8482
	],
	"./aboutUs/karen.png": [
		83238,
		3238
	],
	"./aboutUs/newEra.png": [
		20601,
		601
	],
	"./aboutUs/newEraLight.png": [
		97837,
		7837
	],
	"./aboutUs/samantha.png": [
		98156,
		8156
	],
	"./aboutUs/yoHealthTitle.png": [
		13193,
		3193
	],
	"./addModel.svg": [
		29591,
		9591
	],
	"./apartmentBooking.png": [
		22740,
		2740
	],
	"./arm-construct.png": [
		10165,
		165
	],
	"./asset.png": [
		52963,
		2963
	],
	"./avatar.png": [
		75536,
		5536
	],
	"./avatarActions/chill.png": [
		72580,
		2580
	],
	"./avatarActions/clap.png": [
		77706,
		7706
	],
	"./avatarActions/greeting.png": [
		69433,
		9433
	],
	"./avatarActions/handup.png": [
		16668,
		6668
	],
	"./avatarActions/hiphop.png": [
		4084,
		4084
	],
	"./avatarActions/samba.png": [
		11608,
		1608
	],
	"./avatarActions/shuffling.png": [
		37208,
		7208
	],
	"./avatarActions/twist.png": [
		25483,
		5483
	],
	"./avatars/avatar-1.png": [
		69607
	],
	"./avatars/avatar-2.png": [
		66956,
		6956
	],
	"./bestRace.png": [
		71706,
		1706
	],
	"./brands/akn.png": [
		56198,
		6198
	],
	"./brands/arleAM.png": [
		59048,
		9048
	],
	"./brands/creedrooms.png": [
		65351,
		5351
	],
	"./brands/fast.png": [
		56896,
		6896
	],
	"./brands/fast2.png": [
		77776,
		7776
	],
	"./brands/panda.png": [
		46940,
		6940
	],
	"./brands/popok.png": [
		33511,
		3511
	],
	"./brands/stretch.png": [
		83751,
		3751
	],
	"./brands/ucraft.png": [
		54243,
		4243
	],
	"./brands/ucraft2.png": [
		55705,
		5705
	],
	"./brands/vbet.png": [
		22037,
		2037
	],
	"./bubbleSliderImg1.png": [
		30520,
		520
	],
	"./bubbleSliderImg2.png": [
		76275,
		6275
	],
	"./bubbleSliderImg3.png": [
		37418,
		7418
	],
	"./bubbleSliderSmallImg1.png": [
		84339,
		4339
	],
	"./businessPage/card1.png": [
		45242,
		5242
	],
	"./businessPage/card2.png": [
		53553,
		3553
	],
	"./businessPage/card3.png": [
		13608,
		3608
	],
	"./businessPage/featureImage1.png": [
		49843,
		9843
	],
	"./businessPage/featureImage2.png": [
		4088,
		4088
	],
	"./businessPage/featureImage3.png": [
		25217,
		5217
	],
	"./businessPage/title-shadow.png": [
		85962,
		5962
	],
	"./buy.svg": [
		33437,
		3437
	],
	"./calendar.svg": [
		83249,
		3249
	],
	"./close-dark.svg": [
		48574,
		8574
	],
	"./close.svg": [
		7733,
		7733
	],
	"./contactUsPage/plane.png": [
		68361,
		8361
	],
	"./dashboard-img1.png": [
		79440,
		9440
	],
	"./delete.svg": [
		10154,
		154
	],
	"./download.svg": [
		29359,
		9359
	],
	"./emojies/hallas/102.png": [
		75053,
		5053
	],
	"./emojies/hallas/103.png": [
		48900,
		8900
	],
	"./emojies/hallas/104.png": [
		42491,
		2491
	],
	"./emojies/hallas/105.png": [
		93490,
		3490
	],
	"./emojies/hallas/106.png": [
		58633,
		8633
	],
	"./emojies/hallas/107.png": [
		3808,
		3808
	],
	"./emojies/hallas/108.png": [
		31079,
		1079
	],
	"./emojies/hallas/109.png": [
		59742,
		9742
	],
	"./emojies/hallas/110.png": [
		35508,
		5508
	],
	"./emojies/hallas/111.png": [
		52189,
		2189
	],
	"./emojies/hallas/112.png": [
		70982,
		982
	],
	"./emojies/hallas/113.png": [
		9999,
		9999
	],
	"./emojies/simple/angry.png": [
		61094
	],
	"./emojies/simple/clap.png": [
		20975
	],
	"./emojies/simple/cool.png": [
		4030
	],
	"./emojies/simple/evil-face.png": [
		17101
	],
	"./emojies/simple/like.png": [
		18816
	],
	"./emojies/simple/lovely.png": [
		19552
	],
	"./emojies/simple/mind-blow.png": [
		89356
	],
	"./emojies/simple/shocked.png": [
		18344
	],
	"./emojies/simple/wow.png": [
		55116
	],
	"./error.png": [
		69697
	],
	"./event.png": [
		25347,
		5347
	],
	"./ftn-coin.gif": [
		83598,
		3598
	],
	"./ftn-coin.png": [
		84065,
		4065
	],
	"./full-screen.svg": [
		51945,
		1945
	],
	"./games-sidebar-img.png": [
		2931,
		2931
	],
	"./garage.png": [
		61444,
		1444
	],
	"./half-building.png": [
		94527,
		4527
	],
	"./homeWithBg.png": [
		23275,
		3275
	],
	"./homepage-banner-content.png": [
		92204,
		2204
	],
	"./homepage-banner.png": [
		13756,
		3756
	],
	"./hoory.png": [
		75550,
		5550
	],
	"./hotel-img.png": [
		96191,
		6191
	],
	"./image_not_found.png": [
		50979,
		979
	],
	"./imgBannerSlider1.png": [
		78298,
		8298
	],
	"./imgBannerSlider2.png": [
		54545,
		4545
	],
	"./imgBannerSlider3.png": [
		6152,
		6152
	],
	"./info.svg": [
		79339,
		9339
	],
	"./landingPage/landingPageCalendar.png": [
		76004,
		6004
	],
	"./landingPage/meal1.png": [
		10224,
		224
	],
	"./landingPage/meal2.png": [
		75627,
		5627
	],
	"./landingPage/menuFrame.png": [
		36306,
		6306
	],
	"./landingPage/reserveFrame.png": [
		17355,
		7355
	],
	"./landingPage/restaurant1.png": [
		80036,
		36
	],
	"./landingPage/restaurant2.png": [
		18335,
		8335
	],
	"./landingPage/restaurant3.png": [
		38358,
		8358
	],
	"./landingPage/restaurant4.png": [
		38185,
		8185
	],
	"./landingPage/title-shadow.png": [
		99899,
		9899
	],
	"./landingPage/urlFrame.png": [
		43886,
		3886
	],
	"./list-img.png": [
		58345,
		8345
	],
	"./login-bg.png": [
		90130,
		130
	],
	"./logo.png": [
		82806,
		2806
	],
	"./logoSimple.png": [
		6300,
		6300
	],
	"./logos/YoHealthLogo.gif": [
		44680,
		4680
	],
	"./logos/apple-logo.png": [
		20748,
		748
	],
	"./logos/apple.png": [
		20666,
		666
	],
	"./logos/cerebrum.png": [
		74177,
		4177
	],
	"./logos/cerebrum.svg": [
		54877,
		4877
	],
	"./logos/cerebrum_circled.png": [
		28420,
		8420
	],
	"./logos/fastex.png": [
		63585,
		3585
	],
	"./logos/google-logo.png": [
		81909,
		1909
	],
	"./logos/google.png": [
		90565,
		565
	],
	"./logos/loader.svg": [
		52353,
		2353
	],
	"./logos/metamask.svg": [
		32107,
		2107
	],
	"./logos/popokProperty.png": [
		49682,
		9682
	],
	"./logos/wallet.png": [
		72579,
		2579
	],
	"./logos/yo-login.png": [
		20572,
		572
	],
	"./mapMarkers/buy.svg": [
		18029,
		8029
	],
	"./mapMarkers/open.svg": [
		33983,
		3983
	],
	"./open.svg": [
		3791,
		3791
	],
	"./openAye.svg": [
		11722,
		1722
	],
	"./ortak/check_your_results.png": [
		67598,
		7598
	],
	"./ortak/enter_the_draw.png": [
		7168,
		7168
	],
	"./ortak/fast_coin.png": [
		80225,
		225
	],
	"./ortak/fast_coin_2.png": [
		85018,
		5018
	],
	"./ortak/fast_coin_3.png": [
		86243,
		6243
	],
	"./ortak/get_your_ticket_mobile.png": [
		74569,
		4569
	],
	"./ortak/get_your_tickets.png": [
		7547,
		7547
	],
	"./ortak/ortak_key.png": [
		7038,
		7038
	],
	"./ortak/popok_img.jpg": [
		8652,
		8652
	],
	"./ortak/spiral.png": [
		6056,
		6056
	],
	"./ortak/ticket_number_and_prize.png": [
		43692,
		3692
	],
	"./ortak/welcome_ortak.png": [
		3535,
		3535
	],
	"./ortakLogo.svg": [
		64121,
		4121
	],
	"./ortakLogoMobile.svg": [
		2439,
		2439
	],
	"./persons.png": [
		12021,
		2021
	],
	"./presentLaywe.png": [
		49870,
		9870
	],
	"./qr-code.png": [
		8270,
		8270
	],
	"./qr2.png": [
		12906,
		2906
	],
	"./slider-img1.png": [
		55453,
		5453
	],
	"./slider-logo.png": [
		99542,
		9542
	],
	"./space.png": [
		50697,
		697
	],
	"./testImg.png": [
		9930,
		9930
	],
	"./toasts/error.svg": [
		2904,
		2904
	],
	"./toasts/info.svg": [
		24714,
		4714
	],
	"./toasts/success.svg": [
		13187,
		3187
	],
	"./upload.svg": [
		44784,
		4784
	],
	"./vigogo.png": [
		82700,
		2700
	],
	"./wallet/fireBlocks.png": [
		87055,
		7055
	],
	"./wallet/ledger.png": [
		36598,
		6598
	],
	"./wallet/viewAll.png": [
		70069,
		69
	],
	"./wallet/zerion.png": [
		2366,
		2366
	],
	"./walletImage.png": [
		41285,
		1285
	],
	"./wave.svg": [
		89680,
		9680
	],
	"./yo-program-images/program-1.png": [
		28942,
		8942
	],
	"./yo-program-images/program-2.png": [
		17093,
		7093
	],
	"./yo-program-images/program-3.png": [
		87676,
		7676
	],
	"./yo-program-images/program-4.png": [
		71283,
		1283
	],
	"./yo-program-images/program-5.png": [
		32426,
		2426
	],
	"./yo.png": [
		45631,
		5631
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 66704;
module.exports = webpackAsyncContext;